module.exports = __webpack_public_path__ + "point-shop-ic.svg?961681436f337ae70a6bd41b59904047";